/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  validatePhoneNumberLength,
} from "libphonenumber-js";
import moment from "moment";

import countries_codes from "components/ui/MyPhoneInput/codes";

const validator = (key, value) => {
  if (value.length < 1) {
    const allowed = [
      "place name",
      "email",
      "brief",
      "description",
      "last name",
      "contact number",
      "address",
      "lat",
      "lng",
    ];

    if (allowed.includes(key)) {
      return true;
    }

    return false;
  }

  if (key.includes("number")) {
    if (value.match(/[a-zA-Z]/g)) {
      return false;
    }
  }

  if (key.includes("password")) {
    if (value.length < 6) {
      return false;
    }
  }

  if (key.includes("username")) {
    if (value.length < 3 || value.match(/\s/g)) {
      return false;
    }
  }

  if (key.includes("date")) {
    if (
      moment(value, "YYYY/M/D", true).isValid() ||
      moment(value, "YYYY/MM/DD", true).isValid() ||
      moment(value, "YYYY-M-D", true).isValid() ||
      moment(value, "YYYY-MM-DD", true).isValid()
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (key.includes("from") || key.includes("to")) {
    const val = value.trim();
    if (
      moment(val, "HH:mm", true).isValid() ||
      moment(val, "HH:mm:ss", true).isValid()
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (key.includes("email")) {
    if (
      !value.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
    ) {
      return false;
    }
  }

  return true;
};

// only allow english letters
export const verifyOnlyEnglish = (word) => {
  const value = word.replace(/[^a-zA-Z\s]/g, "");
  return value;
};

// only allow letters no matter the language
export const verifyOnlyLetters = (word) => {
  const value = word.replace(/[^\p{L}\s]+/gu, "");
  return value;
};

export const verifyLettersNumbersAndEmail = (word) => {
  const value = word.replace(/[^a-zA-Z0-9@+._-\s]/g, "");
  return value;
};

export const verifyEmail = (email) => {
  let value = email.replace(/[^a-zA-Z0-9@._+-]/g, "");
  value = value.replaceAll(" ", "");
  return value;
};

// export const verifyOnlyNumbers = (word) => {
//   const value = word.replace(/[^0-9]/g, "");
//   return value;
// };

export const verifyLettersAndNumbers = (word) => {
  const value = word.replace(/[^a-zA-Z0-9]/g, "");
  return value;
};

export const verifyStrongPassword = (word, minLength = 8) => {
  const lowerCaseLetters = /[a-z]/g;
  if (!word.match(lowerCaseLetters)) {
    return "Password must contain at least one lowercase letter.";
  }

  // Validate capital letters
  const upperCaseLetters = /[A-Z]/g;
  if (!word.match(upperCaseLetters)) {
    return "Password must contain at least one uppercase letter.";
  }

  // Validate numbers
  const numbers = /[0-9]/g;
  if (!word.match(numbers)) {
    return "Password must contain at least one number.";
  }

  if (word.length < minLength) {
    return `password must be at least ${minLength} characters long.`;
  }

  return true;
};

export const removeWhiteSpace = (word) => {
  const value = word.replace(/\s/g, "");
  return value;
};

export const verifyOnlyNumbers = (word) => {
  // only allow numbers and remove spaces
  let value = word.replace(/[^0-9]/g, "");
  value = value.replace(" ", "");
  return value;
};

export const removeLeadingZeros = (value) => {
  let newValue = value;
  if (/^0{2,}$/.test(newValue)) {
    newValue = "0";
  } else if (newValue.length > 1) {
    newValue = newValue.replace(/^0+/, "");
  }

  return newValue;
};

export const validatePhoneNumber = (phoneNumber, countryCode) => {
  const countryId = countries_codes.filter(
    (country) => country.value === countryCode,
  )?.[0]?.id;

  const isPossible = isPossiblePhoneNumber(phoneNumber, countryId);
  const isValid = isValidPhoneNumber(phoneNumber, countryId);

  const isValidLength =
    validatePhoneNumberLength(phoneNumber, countryId) === undefined;

  return isPossible && isValid && isValidLength;
};

export default validator;
